"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.StyledUserSocial = exports.StyledUserName = exports.StyledUserLink = exports.StyledUserInfo = exports.StyledUser = void 0;

var _user = _interopRequireDefault(require("./user"));

var _userLink = _interopRequireDefault(require("./user-link"));

var _user2 = require("./user.styles");

exports.StyledUser = _user2.StyledUser;
exports.StyledUserInfo = _user2.StyledUserInfo;
exports.StyledUserName = _user2.StyledUserName;
exports.StyledUserSocial = _user2.StyledUserSocial;
exports.StyledUserLink = _user2.StyledUserLink;
_user.default.Link = _userLink.default;
var _default = _user.default;
exports.default = _default;